import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import PrivateRoute from './components/PrivateRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Welcome from './pages/Welcome'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import SurveyList from './pages/SurveyList'
import SurveyForm from './pages/SurveyForm'
import OperationCalendar from './pages/OperationCalendar'
import Invoice from './pages/Invoice'
import PublicPasswordChange from './pages/PublicPasswordChange'
import Admin from './pages/Admin'
import ToDeveloper from './pages/ToDeveloper'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './App.css'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/public-password-change" element={<PublicPasswordChange />} />
          <Route path="/welcome" element={<Welcome />} />
          
          <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/surveys" element={<SurveyList />} />
            <Route path="/surveys/new" element={<SurveyForm />} />
            <Route path="/surveys/:id/edit" element={<SurveyForm />} />
            <Route path="/surveys/:id/invoice" element={<Invoice />} />
            <Route path="/operations" element={<OperationCalendar />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/to-developer" element={<ToDeveloper />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App

